<template>
    <div class="main_container">
        <van-popover id="drop_down_id" v-model:show="showPopover" :actions="actions">
            <template #reference>
                <van-row class="dropDown_container"
                   >
                    <van-col span="22">{{ selectAction.text }}</van-col>
                    <van-col span="2">
                        <div v-if="!showPopover" class="dropDown"> <img src="@/assets/agent/sanjiao_bai.png" alt="">
                        </div>
                        <div v-if="showPopover" class="dropDownUp"> <img src="@/assets/agent/sanjiao.png" alt=""></div>
                    </van-col>
                </van-row>
            </template>
            <template #default>
                <van-row class="option_card">
                    <van-col span="24" class="option_row"
                        :style="{ background: selectAction.id == item.id ? 'linear-gradient(180deg,#ff3d9e,#fd66b1)' : '' }" v-for="item in actions"
                        :key="item.text" @click="onSelect(item)">
                        {{ item.text }}</van-col>
                </van-row>
            </template>
        </van-popover>
    </div>

</template>

<script setup lang="ts">
import { ref, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const showPopover = ref(false);

const actions = ref([
    { text: t('agent.directRegistration'), id: 1 },
    { text: t('agent.commissionTeam'), id: 2 },
]);
const selectAction = ref(actions.value[0])
const emits = defineEmits(['setActiveType'])
const onSelect = (item: any) => {
    selectAction.value = item
    emits('setActiveType', selectAction.value.id)
    setTimeout(() => { showPopover.value = false }, 200)
}
const close = () => {
   showPopover.value = false 
}

defineExpose({
    close
})
</script>

<style scoped>
.main_container>>>.van-popover__wrapper {
    display: flex;
}

.dropDown_container {
    border-radius: 10px;
    background: #232129;
    width: 100%;
    padding: 5px 15px;
    color: #fe0;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.dropDown img {
    width: 15px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 30px;
    padding:1px;
}

.option_card {
    padding: 10px 0;
    border-radius: 10px;
    background: linear-gradient(270deg,#40294f,#3e2e4b);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    overflow: hidden;
    width: 360px;
    font-size: 15px;
    color: #FFFFFF;
}

.option_row {
    padding: 10px;
}

.dropDownUp img {
    width: 15px;
    background: #FFFFFF;
    border-radius: 30px;
    padding: 1px;
}

#drop_down_id>>>.van-popover__arrow {
    border-bottom-color: transparent;
}

#drop_down_id>>>.van-popover__content {
    background: transparent;
}
</style>